module.exports = __webpack_public_path__ + "media/common/js/components/content-units/templates/innogy-style/i1-2-19222ab10abd352b8111d3f7f41bbc1d.svg";